export type CivilDatePreset = 'today' | 'thisWeek' | 'lastWeek' | 'thisMonth' | 'lastMonth';

export type CheckInDatePreset = CivilDatePreset | 'nextWeek' | 'nextMonth';

export type DateRangePreset = CivilDatePreset | CheckInDatePreset;

export const CIVIL_DATE_PRESETS: CivilDatePreset[] = ['today', 'thisWeek', 'lastWeek', 'thisMonth', 'lastMonth'];

export const CHECK_IN_DATE_PRESETS: CheckInDatePreset[] = [...CIVIL_DATE_PRESETS, 'nextWeek', 'nextMonth'];

export const CIVIL_DATE_PRESET_LABELS: Record<DateRangePreset, string> = {
	today: 'Hoy',
	thisWeek: 'Esta semana',
	lastWeek: 'Semana pasada',
	nextWeek: 'Próxima semana',
	thisMonth: 'Este mes',
	lastMonth: 'Mes pasado',
	nextMonth: 'Próximo mes',
};

export const formatDateYmd = (date: Date): string => {
	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, '0');
	const day = String(date.getDate()).padStart(2, '0');
	return `${year}-${month}-${day}`;
};

export const getDateRangeFromPreset = (preset: DateRangePreset): { from: Date; to: Date } => {
	const today = new Date();
	today.setHours(0, 0, 0, 0);

	switch (preset) {
		case 'today':
			return { from: new Date(today), to: new Date(today) };

		case 'thisWeek': {
			const startOfWeek = new Date(today);
			startOfWeek.setDate(today.getDate() - today.getDay());
			const endOfWeek = new Date(startOfWeek);
			endOfWeek.setDate(startOfWeek.getDate() + 6);
			return { from: startOfWeek, to: endOfWeek };
		}

		case 'lastWeek': {
			const endOfLastWeek = new Date(today);
			endOfLastWeek.setDate(today.getDate() - today.getDay() - 1);
			const startOfLastWeek = new Date(endOfLastWeek);
			startOfLastWeek.setDate(endOfLastWeek.getDate() - 6);
			return { from: startOfLastWeek, to: endOfLastWeek };
		}

		case 'thisMonth': {
			const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
			const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
			return { from: startOfMonth, to: endOfMonth };
		}

		case 'lastMonth': {
			const startOfLastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
			const endOfLastMonth = new Date(today.getFullYear(), today.getMonth(), 0);
			return { from: startOfLastMonth, to: endOfLastMonth };
		}

		case 'nextWeek': {
			const startOfNextWeek = new Date(today);
			startOfNextWeek.setDate(today.getDate() - today.getDay() + 7);
			const endOfNextWeek = new Date(startOfNextWeek);
			endOfNextWeek.setDate(startOfNextWeek.getDate() + 6);
			return { from: startOfNextWeek, to: endOfNextWeek };
		}

		case 'nextMonth': {
			const startOfNextMonth = new Date(today.getFullYear(), today.getMonth() + 1, 1);
			const endOfNextMonth = new Date(today.getFullYear(), today.getMonth() + 2, 0);
			return { from: startOfNextMonth, to: endOfNextMonth };
		}

		default:
			return { from: new Date(today), to: new Date(today) };
	}
};

export const formatDateRangeLabel = (from: Date, to: Date): string => {
	const fmt = (date: Date) =>
		`${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}`;
	return `${fmt(from)} → ${fmt(to)}`;
};
